/* eslint-disable react-hooks/exhaustive-deps */
import { LayerGroup, Trash } from '@styled-icons/fa-solid';
import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  normaliseBoolean,
  systemReferenceHasAnyStatusErrors,
  validateSystemReferenceFromStatus,
} from '../../utils/loads';
import { PlusCircle } from '@styled-icons/fa-solid';
import AddSubtaskModal from '../EpoListLoads/Details/Tabs/AddSubtaskModal';
import { addSubtask } from '../apiCalls';
import {
  deleteChed,
  getListLoad,
  getNewLoadQaVat,
  postC21Submit,
  postEADSubmit,
  postFFDSubmit,
  postListLoad,
  postSDISubmit,
  postSFDSubmit,
} from '../apiCalls';
import { submitIEImport, submitIEExport } from '../../api/thymeIT';
import ArrivalConfirmation from '../ArrivalConfirmation';
import DataTable from '../DataTable';
import { useDataTableHandle } from '../DataTable/DataTable';
import { DeclarationsButton } from '../DeclarationsButton';
import ResubmissionModal from '../EpoListLoads/Details/Tabs/ResubmissionModal';
import { GoogleAnalyticsContext } from '../GoogleAnalytics';
import '../../styles/gridEdit.css';
import LoadStatusIcon from '../LoadStatusIcon/LoadStatusIcon';
import '../main.css';
import AuthModal from '../Newload/AuthModal';
import PermissionDeniedModal from '../Newload/PermissionDeniedModal/PermissionDeniedModal';
import QAErrors from '../Newload/QAChecklistTab/QAErrors/QAErrors';
import {
  getDutyRatesFromItems,
  getIsVatLiable,
  convertToGbp,
  fetchAdjExchangeRate,
} from '../Newload/QAChecklistTab/utils';
import { ShowIf, useSecurity } from '../Security/security';
import StatusRefreshButton from '../StatusRefreshButton';
import ConfirmationModal from '../ConfirmationModal';
import { StoreContext } from '../Store';
import './loaddetails.css';
import LoadHeader from './LoadHeader';
import ToastNotification from '../Toast/ToastNotification';
import { parseClearanceDate } from '../../utils/stringUtils';
import { ImportType } from '../../utils/enums';

const GENERIC_ERROR =
  'An error occurred while resubmitting the load. Please try again. If the problem persists, please contact IT.';
const SUBTASK_ADD_SUCCESS_MSG = 'Subtask added successfully!';
const SUBTASK_INVALID_ROUTE_MSG = 'Invalid route for Subtask';

const LoadStatus = (props) => {
  const [requestFailed, setRequestFailed] = useState(false);
  const loadNumber = props.invoicenumber;
  const isReadOnly = !!props?.isReadOnly;
  const store = useContext(StoreContext);
  const ga = useContext(GoogleAnalyticsContext);
  const productItemsList = store.validatedRowsReadyToSubmit[0];
  const exchangeRate = store.exchangeRate[0];

  const [showArrivalModal, setShowArrivalModal] = useState(false);
  const [modalItem, setModalItem] = useState(null);
  const [error, setError] = useState();
  const [showResubmissionModal, setShowResubmissionModal] = useState(false);
  const [systemReferenceHasErrors, setSystemReferenceHasErrors] = useState();
  const [hasExciseGoods, setHasExciseGoods] = useState(false);
  const [hasOtherDuty, setHasOtherDuty] = useState(false);
  const [liability, setLiability] = useState(false);
  const [vatType, setVatType] = useState('');
  const consignee = store.consignee[0];
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showPermissionDeniedModal, setShowPermissionDeniedModal] = useState(false);
  const [onLoginConfirmType, setOnLoginConfirmType] = useState('');
  const [loadingDutyData, setLoadingDutyData] = useState(false);
  const [dutyRatesError, setDutyRatesError] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastConfig, setToastConfig] = useState({ type: 'success', message: '' });

  const showStatusToast = (message, variant = 'success') => {
    setToastConfig({ type: variant === 'danger' ? 'error' : 'success', message });
    setShowToast(true);
  };
  const [showAddSubtaskModal, setShowAddSubtaskModal] = useState(false);
  const [sfdRow, setSfdRow] = useState(null);

  const [resubmitError, setResubmitError] = useState(null);

  const headerData = props.headerData;

  const { validateRole } = useSecurity();
  const isDutyUser = validateRole({ isDutyUser: true });
  const isOpsUser = validateRole({ department: 'OPS' });
  const hasDutyOrExcise = liability || hasExciseGoods || hasOtherDuty;
  const canProceedWithoutDutyWarning = isDutyUser || isOpsUser || !hasDutyOrExcise;

  useEffect(() => {
    async function fetchData() {
      try {
        await refreshGrid();
      } catch {
        setRequestFailed(true);
      }
    }
    fetchData();
  }, []);

  const refreshGrid = async () => {
    try {
      const data = await getListLoad('status', loadNumber);
      store.gridItems[1](data);
      const sfd = data.find((item) => item['Additional Information'] === ImportType.SFD);
      setSfdRow(sfd);

      if (sfd?.CustomsAcceptanceDate) {
        const { date, time } = parseClearanceDate(sfd.CustomsAcceptanceDate);
        store.portArrivalDate[1](date);
        store.portArrivalTime[1](time);
      } else {
        store.portArrivalDate[1](null);
        store.portArrivalTime[1](null);
      }
    } catch {
      setRequestFailed(true);
    }
  };

  const handleSdiClick = (item) => {
    if (canProceedWithoutDutyWarning) {
      handleOpenModal(item);
    } else {
      setShowPermissionDeniedModal(true);
    }
  };

  const handleOpenModal = (item) => {
    setModalItem(item);
    setShowArrivalModal(true);
  };

  const handleSubmit = async () => {
    setError();
    const findDoc = (type) => dataHandle.current.modifiedData.find((row) => row['Additional Information'] === type);

    const preSubmitChecks = [
      { type: 'SDI', message: 'Please request SDI (see button) before submitting a system reference number' },
      { type: 'SFD', message: 'Please request an SFD (see button) before submitting MUCR/UCN reference number' },
      { type: 'FFD', message: 'Please request an FFD (see button) before submitting MUCR/UCN reference number' },
      { type: 'C21', message: 'Please request an C21 (see button) before submitting MUCR/UCN reference number' },
    ];

    const hasBlockingDoc = preSubmitChecks.some(({ type, message }) => {
      const doc = findDoc(type);
      if (doc && doc.Status === 'Submitted' && !!doc['System Ref No.']) {
        setError(message);
        return true;
      }
      return false;
    });
    if (hasBlockingDoc) return;

    const updatedCells = [];
    let i = 0;
    for (const row of dataHandle.current.modifiedData) {
      const system = row['System'];
      const refNo = row['System Ref No.'].toUpperCase();

      updatedCells.push({
        colname: 'System',
        rowid: row.id,
        staterow: i++,
        value: system,
      });

      updatedCells.push({
        colname: 'SystemRefNo',
        rowid: row.id,
        staterow: i++,
        value: refNo,
      });
    }
    const invLinked = dataHandle.current.modifiedData.find((row) => {
      return row['Form type'] === 'Inventory linked release';
    });
    if (invLinked) {
      updatedCells.push({
        colname: 'PortArrived',
        rowid: invLinked.id,
        staterow: i++,
        value: (invLinked.PortArrived?.id ? invLinked.PortArrived.id : invLinked.PortArrived) ?? null,
      });
    }

    try {
      const data = await postListLoad(updatedCells, 'status');
      if (data[0].completed === 'Updated') {
        store.saved[1](data);
        await refreshGrid();
      }
    } catch (err) {
      console.error(err);
      alert('Error saving to DB');
    }
  };

  useEffect(() => {
    let cancelled = false;

    const fetchDutyRates = async () => {
      setLoadingDutyData(true);
      const vatAdjustment = Number(store.adjustments[0]?.find((adj) => adj.name === 'vatAdjustment')?.amount || 0);
      const vatCurrency = await fetchAdjExchangeRate(
        store.currencyOptions[0],
        Number(store.adjustments[0]?.find((adj) => adj.name === 'vatAdjustment')?.currency || 0),
        store.date[0],
        store.exchangeRateCache
      );
      const vatAdjustmentGbp = Number(convertToGbp(vatAdjustment, vatCurrency));
      const dutyRate = await getDutyRatesFromItems(
        productItemsList,
        exchangeRate,
        vatAdjustmentGbp,
        store.RoiImport[0]
      );
      if (cancelled) return;
      const dutyData = dutyRate.data;
      setDutyRatesError(dutyRate.error);

      if (dutyData?.length) {
        setHasExciseGoods(dutyData.some((duty) => !!duty.excise));
        setHasOtherDuty(dutyData.some((duty) => !!duty.additionalDuties));

        const isPva = vatType === 'PVA';
        const hasDutyBeenSaved = !productItemsList.every((product) => product.dutyLiability === null);
        let hasLiability = false;
        if (hasDutyBeenSaved) {
          hasLiability = productItemsList.some((row) => {
            if (isPva) {
              return !['-', '0', 0].includes(row.dutyLiability) && !!row.dutyLiability;
            }
            return (
              (!['-', '0', 0].includes(row.dutyLiability) && !!row.dutyLiability) ||
              (!['-', '0', 0].includes(row.vatLiability) && !!row.vatLiability)
            );
          });
        } else {
          const hasDuty = dutyData.some((item) => !!item.dutyLiability);
          const hasVat = productItemsList.some((item) => getIsVatLiable(item.VAT) && item.itemValue);

          hasLiability = isPva ? hasDuty : hasDuty || hasVat;
        }

        setLiability(hasLiability);
      }
      if (!cancelled) {
        setLoadingDutyData(false);
      }
    };

    if (!productItemsList?.length || !exchangeRate) return;
    if (consignee === undefined || consignee === null || consignee === '') return;

    fetchDutyRates();

    return () => {
      cancelled = true;
    };
  }, [productItemsList, exchangeRate, vatType, consignee]);

  useEffect(() => {
    if (consignee === undefined || consignee === null || consignee === '') return;

    let cancelled = false;
    const fetchVatData = async () => {
      const data = await getNewLoadQaVat(consignee);
      if (cancelled) return;
      setVatType(data?.[0]?.vatMessage ?? '');
    };

    fetchVatData();

    return () => {
      cancelled = true;
    };
  }, [consignee]);

  const authConfirm = () => {
    if (onLoginConfirmType === 'doc') {
      handleDocSubmit();
    }

    if (onLoginConfirmType === 'c21') {
      handleC21Submit();
    }
  };

  const handleDocClick = () => {
    if (canProceedWithoutDutyWarning) {
      handleDocSubmit();
    } else {
      setShowLoginModal(true);
      setOnLoginConfirmType('doc');
    }
  };

  const handleDocSubmit = async () => {
    const sfdRequest = {
      id: loadNumber,
    };
    try {
      await postSFDSubmit(sfdRequest);
      await refreshGrid();
    } catch (err) {
      console.error(err);
      alert('Error sending SFD');
    }
    setShowLoginModal(false);
  };

  const handleC21Click = () => {
    if (canProceedWithoutDutyWarning) {
      handleC21Submit();
    } else {
      setShowLoginModal(true);
      setOnLoginConfirmType('c21');
    }
  };

  const handleC21Submit = async () => {
    const c21Request = {
      id: loadNumber,
    };
    try {
      await postC21Submit(c21Request);
      await refreshGrid();
    } catch (err) {
      console.error(err);
      alert('Error sending C21');
    }
    setShowLoginModal(false);
  };

  const handleFFDClick = () => {
    if (canProceedWithoutDutyWarning) {
      handleFFDSubmit();
    } else {
      setShowPermissionDeniedModal(true);
    }
  };

  const handleFFDSubmit = async () => {
    const ffdRequest = {
      id: loadNumber,
    };
    try {
      await postFFDSubmit(ffdRequest);
      await refreshGrid();
    } catch (err) {
      console.error(err);
      alert('Error sending FFD');
    }
  };

  const handleModalSubmit = async () => {
    const sdiRequest = {
      id: loadNumber,
      date: store.portArrivalDate[0],
      time: store.portArrivalTime[0],
    };
    try {
      await postSDISubmit(sdiRequest);
      await refreshGrid();
    } catch (err) {
      console.error(err);
      alert('Error sending SDI');
    }
  };

  const dataHandle = useDataTableHandle();

  const handlePortArrived = (item) => {
    return item['Form type'] === 'Inventory linked release' && item['showVesselArrived'] !== false;
  };

  const disableSystemReference = (item) => {
    //For the field to be enable, item shouldn't be locked AND it shouldn't be read only.
    return !item.locked && !isReadOnly;
  };

  const setGATagForResubmission = (declarationType) => {
    if (ga.gaInitialized && declarationType) {
      window?.gtag?.('event', `${declarationType} resubmitted`, {
        event_category: 'Resubmit Declaration',
      });
    }
  };

  const submitDeclaration = async () => {
    try {
      const requiresDate = showResubmissionModal == 'SDI';

      const payload = {
        id: loadNumber,
        resubmission: true,
        ...(requiresDate && {
          date: new Date().toISOString().split('T')[0],
          time: store.portArrivalTime[0] || '12:00',
        }),
      };
      switch (showResubmissionModal) {
        case 'SDI':
          await postSDISubmit(payload);
          break;
        case 'SFD':
          await postSFDSubmit(payload);
          break;
        case 'C21':
          await postC21Submit(payload);
          break;
        case 'FFD':
          await postFFDSubmit(payload);
          break;
        case 'GB Export':
          await postEADSubmit(payload);
          break;
        case 'IE Import':
          await submitIEImport(payload.id, headerData?.Currency);
          break;
        case 'IE Export':
          await submitIEExport(payload.id);
          break;
        default:
          alert('No declaration type selected for resubmission: ' + showResubmissionModal);
          return;
      }
      setGATagForResubmission(showResubmissionModal);
      await refreshGrid();
    } catch (err) {
      console.error('Resubmit Error:', err);

      try {
        const error = JSON.parse(err.message);
        setResubmitError(error);
      } catch (parseError) {
        console.error('Parse Error:', parseError);
        setResubmitError({
          message: GENERIC_ERROR,
        });
      }
    }
  };

  const getRefreshMessage = (item) => {
    if (item?.['System Ref No.']) {
      const systemName = item?.['System'] || 'Descartes';
      return `You are unable to submit this declaration as a response has been received from ${systemName}.`;
    } else if (!item?.resubmissionAvailable && item?.resubmissionDate1) {
      return 'You can only resubmit this declaration two times';
    } else return '';
  };

  const removeRow = async (docId) => {
    if (!docId) {
      showStatusToast('Cannot delete: Document ID is missing', 'danger');
      return;
    }
    try {
      const data = await deleteChed(docId);
      if (data) {
        store.gridItems[1](data);
        await refreshGrid();
      } else {
        // If deleteChed doesn't return data, just refresh
        await refreshGrid();
      }
      showStatusToast('Subtask deleted successfully!');
    } catch (err) {
      console.error('Error deleting subtask:', err);
      showStatusToast('Error deleting subtask. Please try again.', 'danger');
    }
  };

  const handleAddSubtask = async (subtaskData) => {
    try {
      // Must use subTasktId (the ID from API), not the type string
      if (!subtaskData.subTasktId) {
        alert('Error: Subtask ID is missing. Please try again.');
        return;
      }

      const subTaskId = subtaskData.subTasktId;

      const data = await addSubtask(loadNumber, subTaskId, false);
      if (data[0]?.status === 'Failed') {
        showStatusToast(SUBTASK_INVALID_ROUTE_MSG, 'danger');
        return;
      }
      showStatusToast(SUBTASK_ADD_SUCCESS_MSG);
      await refreshGrid();
    } catch (err) {
      console.error(err);
      showStatusToast('Error creating subtask.', 'danger');
    }
  };

  if (requestFailed) return <p>Failed!</p>;

  return (
    <div className="floating-box-newload loaditems">
      <ToastNotification
        show={showToast}
        onClose={() => setShowToast(false)}
        type={toastConfig.type}
        message={toastConfig.message}
      />
      <QAErrors exchangeRate={exchangeRate} dutyRatesError={dutyRatesError} />
      <AuthModal
        show={showLoginModal}
        onHide={() => setShowLoginModal(false)}
        onSuccess={() => authConfirm()}
        title="Confirm Duty Override"
        mainMessage="You are attempting to submit this on a load with duty."
        instructionMessage="Please enter your password to confirm."
      />
      <PermissionDeniedModal show={showPermissionDeniedModal} onHide={() => setShowPermissionDeniedModal(false)} />
      <ResubmissionModal
        show={showResubmissionModal}
        onHide={() => setShowResubmissionModal(false)}
        submitDeclaration={submitDeclaration}
        referenceNo={headerData?.portalRef}
      />
      <div className="d-flex flex-row justify-content-between">
        <h1 className="floating-box-header-newload loads">Load Status</h1>
        <div className="d-flex flex-column gap-2 justify-content-between align-items-end mb-4">
          <LoadHeader
            portalRef={headerData?.portalRef}
            companyName={headerData?.companyName}
            eoriNumber={headerData?.eoriNumber}
          />
        </div>
      </div>
      <DataTable
        data={store.gridItems[0]}
        className="table-striped table-bordered"
        editable
        handle={dataHandle}
        onMutate={(localData) => {
          const allValid = systemReferenceHasAnyStatusErrors(localData);
          setSystemReferenceHasErrors(allValid);
        }}
      >
        <DataTable.Headers className="bg-white" style={{ fontSize: '13px' }} />
        <DataTable.Column colKey="Form type" header="Transaction Type" />
        <DataTable.Column colKey="Country/Port" header="Location" />
        <DataTable.Column
          colKey="Additional Information"
          header="Additional Information"
          maxWidth="27ch"
          style={{ whiteSpace: 'wrap' }}
        />
        <DataTable.Column colKey="System" header="Customs Software" maxWidth="20ch" />
        <DataTable.Column
          colKey="System Ref No."
          header="System Reference"
          className="m-2 edit-cell system-reference uppercase-text"
          maxWidth="20ch"
          editable={disableSystemReference}
          validator={validateSystemReferenceFromStatus}
        />
        <DataTable.Column
          colKey="PortArrived"
          header="Vessel Arrived"
          className="m-2 edit-cell"
          locked={(item) => {
            return item.locked;
          }}
          editable={handlePortArrived}
        >
          <DataTable.Select
            options={[
              { id: 1, data: 'No' },
              { id: 2, data: 'Yes' },
            ]}
            optionIdKey="id"
            optionDisplayKey="data"
            editable={!isReadOnly}
          />
        </DataTable.Column>
        <DataTable.Column colKey="Status" header="Status">
          {(item) => <LoadStatusIcon status={item} />}
        </DataTable.Column>
        <DataTable.Column header="Submit" style={{ whiteSpace: 'nowrap', width: '1px' }}>
          {(item) => (
            <DeclarationsButton
              C21={item.C21}
              SFD={item.SFD}
              SDI={item.SDI}
              FFD={item.FFD}
              submitUser={item.submitUser}
              refNumber={item.refNumberUser}
              InventoryLinked={item.InventoryLinked}
              Status={item.Status}
              formSubmitted={item.formSubmitted}
              handleOpenModal={() => handleSdiClick(item)}
              handleDocSubmit={() => handleDocClick()}
              handleC21Submit={() => handleC21Click()}
              handleFFDSubmit={() => handleFFDClick()}
              loading={loadingDutyData}
              editable={!isReadOnly}
            />
          )}
        </DataTable.Column>
        <DataTable.Column header="Actions" style={{ whiteSpace: 'nowrap', width: '1.5rem' }}>
          {(item) => (
            <>
              <StatusRefreshButton
                item={item}
                setShowResubmissionModal={setShowResubmissionModal}
                disabled={!item?.resubmissionAvailable || isReadOnly}
                message={getRefreshMessage(item)}
              />
              <ShowIf or={[{ department: 'OPS' }, { department: 'QA' }]}>
                <Link to={`/DeclarationsHistory/${props?.headerData?.id}/${item?.id}`}>
                  <LayerGroup className="text-secondary" width="1rem" height="1rem" />
                </Link>
              </ShowIf>
            </>
          )}
        </DataTable.Column>
        <DataTable.Column
          header="Delete"
          style={{ whiteSpace: 'nowrap', width: '2rem', textAlign: 'center' }}
          className="p-0"
        >
          {(item) => {
            const canDelete = normaliseBoolean(item.isSubTask);

            return (
              <button
                className="subtask-delete-button"
                onClick={() => {
                  if (item.id && canDelete) {
                    removeRow(item.id);
                  } else if (!item.id) {
                    showStatusToast('Cannot delete: Item ID is missing', 'danger');
                  }
                }}
                disabled={!canDelete || !item.id}
                title={
                  canDelete && item.id
                    ? 'Delete subtask'
                    : !item.id
                      ? 'Cannot delete: Missing item ID'
                      : 'Cannot delete this subtask'
                }
              >
                <Trash width="1rem" height="1rem" />
              </button>
            );
          }}
        </DataTable.Column>
      </DataTable>
      <AddSubtaskModal
        show={showAddSubtaskModal}
        onHide={() => setShowAddSubtaskModal(false)}
        onSubmit={handleAddSubtask}
        isEpo={false}
        hasTraderUploadedIpaffs={false}
      />
      <button type="button" className="invoice-add-btn green-text" onClick={() => setShowAddSubtaskModal(true)}>
        <PlusCircle width="1.4rem" height="1.4rem" />
        <span className="text-decoration-underline bold" style={{ fontSize: '1rem' }}>
          Add a Subtask
        </span>
      </button>
      <div className="d-flex flex-row py-3 px-3 mt-4 gap-3 border-top">
        <button className="stepper-button yellow" onClick={props.prevPage}>
          Items
        </button>
        <div className="flex-grow-1" />
        <div className="">
          {error && (
            <div className="alert-danger px-3 py-2 w-100 " style={{ borderRadius: '10px', textAlign: 'center' }}>
              {error}
            </div>
          )}
        </div>
        <div className="flex-grow-1" />
        <button className="stepper-button green" onClick={() => dataHandle.current.reset()}>
          Undo
        </button>
        <button className="stepper-button red" onClick={handleSubmit} disabled={systemReferenceHasErrors}>
          Update
        </button>
      </div>
      <ArrivalConfirmation
        show={showArrivalModal}
        onHide={() => {
          setShowArrivalModal(false);
          setModalItem(null);
        }}
        onConfirm={handleModalSubmit}
        item={modalItem}
        hasSfd={!!sfdRow}
        sfdArrived={!!sfdRow?.CustomsAcceptanceDate}
      />
      <ConfirmationModal
        header="An error occurred"
        show={!!resubmitError}
        onHide={() => setResubmitError(null)}
        hideConfirm
      >
        {resubmitError?.error || GENERIC_ERROR}
      </ConfirmationModal>
    </div>
  );
};

export default LoadStatus;
